export const SET_MODEL = 'SET_MODEL';
export const RESET_MODEL = 'RESET_MODEL';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const RESET_QUESTINS = 'RESET_QUESTINS';
export const ADD_ANSWER = 'ADD_ANSWER';
export const SET_PRICE = 'SET_PRICE';
export const SET_GRADE = 'SET_GRADE';
export const SET_REFUSALS = 'SET_REFUSALS';
export const SET_ERROR_SEARCH = 'SET_ERROR_SEARCH';
export const SET_LOADING = 'SET_LOADING';